import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export const CMS_EDITOR_MODULES = {
  toolbar: [
    [{ font: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ align: [] }],
    ["bold", "italic", "underline", "strike"],
    ["blockquote", "code-block"],
    [{ color: [] }, { background: [] }],
    ["link", "image", "video"],
  ],
};

export default function CmsTextEditor({ value = "", onChange, disabled = false, placeholder = "", name = "content" }) {
  return (
    <ReactQuill
      name={name}
      theme="snow"
      value={value || ""}
      modules={CMS_EDITOR_MODULES}
      readOnly={disabled}
      placeholder={placeholder}
      onChange={onChange}
    />
  );
}
